import { useQuery } from '@tanstack/react-query'

import { graphql, graphql_call } from '../../schemas/server_admin_query'

export const get_admin_user = graphql(`
  query get_admin_user($id: ID!) {
    user(id: $id) {
      id
      uuid
      name
      email
      image
      wallet_address
      roles
    }
  }
`)

export const get_admin_users_by_wallet = graphql(`
  query get_admin_users_by_wallet($wallet_addresses: [String!]!) {
    users_by_wallet(wallet_addresses: $wallet_addresses) {
      id
      uuid
      name
      email
      image
      wallet_address
      wallet_provider
      roles
      active_at
      created_at
      updated_at
      locked
    }
  }
`)

export const get_admin_user_query = (variables: { id: string }) => {
  return graphql_call({
    query: get_admin_user,
    variables,
  })
}

export const get_admin_users_by_wallet_query = (variables: {
  wallet_addresses: string[]
}) => {
  return graphql_call({
    query: get_admin_users_by_wallet,
    variables,
  })
}

export const useAdminUser = (id: string) => {
  return useQuery({
    queryKey: ['adminUser', id],
    queryFn: () => get_admin_user_query({ id }),
    enabled: !!id,
  })
}

export const useAdminUsersByWallet = (walletAddresses: string[]) => {
  return useQuery({
    queryKey: ['adminUsersByWallet', walletAddresses],
    queryFn: () =>
      get_admin_users_by_wallet_query({ wallet_addresses: walletAddresses }),
    enabled: walletAddresses.length > 0,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  })
}
